import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { en, es } from 'vuetify/locale'
import { DEFAULT_HOSPITAL_CONFIG } from '../utils/config/defaultPortalHospitalConfig'
import { derivePortalThemeColors } from '../utils/helpers/portalColorTheme'
import { resolveInitialDarkMode } from '../utils/helpers/portalDarkModePreference'

const CLEAR_ICON = 'mdi-close'

export function createPortalVuetify(primaryColor, secondaryColor) {
  const lightColors = derivePortalThemeColors(
    primaryColor || DEFAULT_HOSPITAL_CONFIG.primaryColor,
    secondaryColor || DEFAULT_HOSPITAL_CONFIG.secondaryColor,
    false,
  )
  const darkColors = derivePortalThemeColors(
    primaryColor || DEFAULT_HOSPITAL_CONFIG.primaryColor,
    secondaryColor || DEFAULT_HOSPITAL_CONFIG.secondaryColor,
    true,
  )
  return createVuetify({
    components,
    directives,
    defaults: {
      VForm: { autocomplete: 'off' },
      VTextField: { clearIcon: CLEAR_ICON, autocomplete: 'off' },
      VTextarea: { autocomplete: 'off' },
      VAutocomplete: { clearIcon: CLEAR_ICON, autocomplete: 'off' },
      VCombobox: { clearIcon: CLEAR_ICON, autocomplete: 'off' },
      VSelect: { clearIcon: CLEAR_ICON },
      VFileInput: { clearIcon: CLEAR_ICON },
      VNumberInput: { clearIcon: CLEAR_ICON, autocomplete: 'off' },
    },
    locale: {
      locale: 'es',
      fallback: 'en',
      messages: { es, en },
    },
    theme: {
      defaultTheme: resolveInitialDarkMode() ? 'dark' : 'light',
      themes: {
        light: {
          dark: false,
          colors: {
            background: lightColors.background,
            surface: lightColors.surface,
            'on-surface': lightColors.onSurface,
            primary: lightColors.primary,
            'on-primary': lightColors.onPrimary,
            secondary: lightColors.secondary,
            'on-secondary': lightColors.onSecondary,
            success: '#00838F',
          },
        },
        dark: {
          dark: true,
          colors: {
            background: darkColors.background,
            surface: darkColors.surface,
            'on-surface': darkColors.onSurface,
            primary: darkColors.primary,
            'on-primary': darkColors.onPrimary,
            secondary: darkColors.secondary,
            'on-secondary': darkColors.onSecondary,
            success: '#4DB6AC',
          },
        },
      },
    },
  })
}
